import { Pill, Tooltip } from '@iwoca/orion';
import { TApplication } from 'lendingApi/applications.types';
import { APPLICATION_STATUS } from 'utils/applications/applications.config';
import styles from './CompanyCell.module.css';
import { OpenInNewTabButton } from './OpenInNewTabButton/OpenInNewTabButton';

type TProps = { application: TApplication };

const pillData = {
  high_probability_of_offer: {
    color: 'green',
    text: 'High chance of approval',
    tooltip: '80% of comparable applications are approved.',
  },
  medium_probability_of_offer: {
    color: 'yellow',
    text: 'Medium chance of approval',
    tooltip: '50% of comparable applications are approved.',
  },
  low_probability_of_offer: {
    color: 'red',
    text: 'Low chance of approval',
    tooltip: '20% of comparable applications are approved.',
  },
} as const;

export const CompanyCell = ({ application }: TProps) => {
  const { status, company, formal_offer_sets, formal_indicative_offer_sets } =
    application;

  const indicativeOffer =
    formal_indicative_offer_sets?.[0]?.formal_indicative_offers?.[0];

  const hasRelevantOffer =
    !formal_offer_sets?.[0]?.formal_offers?.[0]?.max_amount && indicativeOffer;

  const showPill =
    ![APPLICATION_STATUS.declined, APPLICATION_STATUS.deferred].includes(
      status,
    ) && hasRelevantOffer;

  const probability = indicativeOffer?.probability_of_offer;

  return (
    <div className={styles.companyContainer}>
      <div className={styles.companyDetails}>
        <div className={styles.companyHeaderText}>
          {company?.registered_company_name?.trim() || '-'}
        </div>
        <div>{company?.company_number || ''}</div>
        {showPill && probability && (
          <div className={styles.probabiltyContainer}>
            <Tooltip content={pillData[probability].tooltip} placement="bottom">
              <Pill
                variant={pillData[probability].color}
                size="small"
                className={styles.pill}
              >
                {pillData[probability].text}
              </Pill>
            </Tooltip>
          </div>
        )}
      </div>
      <OpenInNewTabButton application={application} />
    </div>
  );
};
